import { render, staticRenderFns } from "./definitions-list.vue?vue&type=template&id=09a54fb1&"
import script from "./definitions-list.vue?vue&type=script&lang=js&"
export * from "./definitions-list.vue?vue&type=script&lang=js&"
import style0 from "./definitions-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09a54fb1')) {
      api.createRecord('09a54fb1', component.options)
    } else {
      api.reload('09a54fb1', component.options)
    }
    module.hot.accept("./definitions-list.vue?vue&type=template&id=09a54fb1&", function () {
      api.rerender('09a54fb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/morph-parts/definitions-list.vue"
export default component.exports